import React, { Component } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink, Container } from 'reactstrap';
import { Link } from 'react-router-dom';

class Navbarpane extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return (
            <Container>
                <Navbar color="transparent" dark expand="lg" id="staticNav">
                    <NavbarBrand tag={Link} to="/"><img src="https://res.cloudinary.com/stormdragon-designs/image/upload/c_scale,w_200/v1528407534/sdd-horizontal_ymhycv.png" alt="Stormdragon Designs Logo" className="d-inline-block align-middle"/></NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar >
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <NavLink tag={Link} to="/" className="text-white">Home</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} to="/services" className="text-white">Services</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} to="/login" className="text-white">Log In</NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </Container>
        );
    }
}

export default Navbarpane;


// WEBPACK FOOTER //
// ./src/components/Navbar.js